// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AbuseJournalRouteImport } from './routes/abuse-journal'
import { Route as AccountCreatedRouteImport } from './routes/account-created'
import { Route as ActsOfSelfCareRouteImport } from './routes/acts-of-self-care'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AdminTestimonialsRouteImport } from './routes/admin-testimonials'
import { Route as AffirmationsRouteImport } from './routes/affirmations'
import { Route as AiDisclaimerRouteImport } from './routes/ai-disclaimer'
import { Route as AppMembershipRouteImport } from './routes/app-membership'
import { Route as AromatherapyRouteImport } from './routes/aromatherapy'
import { Route as ArtBoardRouteImport } from './routes/art-board'
import { Route as BilateralRouteImport } from './routes/bilateral'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as BrandColorsRouteImport } from './routes/brand-colors'
import { Route as BreathingRouteImport } from './routes/breathing'
import { Route as CbtThoughtCardsRouteImport } from './routes/cbt-thought-cards'
import { Route as CheckInRouteImport } from './routes/check-in'
import { Route as CheckinUnsubscribeRouteImport } from './routes/checkin-unsubscribe'
import { Route as ChooseMembershipRouteImport } from './routes/choose-membership'
import { Route as ComingSoonRouteImport } from './routes/coming-soon'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as CommunityGuidelinesRouteImport } from './routes/community-guidelines'
import { Route as CompleteMembershipRouteImport } from './routes/complete-membership'
import { Route as ConfirmSubscriptionRouteImport } from './routes/confirm-subscription'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as CoursesRouteImport } from './routes/courses'
import { Route as CreativeExpressionRouteImport } from './routes/creative-expression'
import { Route as CreativeReflectionRouteImport } from './routes/creative-reflection'
import { Route as CrisisRouteImport } from './routes/crisis'
import { Route as DailyPracticeRouteImport } from './routes/daily-practice'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DbtSkillsRouteImport } from './routes/dbt-skills'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as DissociationJournalRouteImport } from './routes/dissociation-journal'
import { Route as DreamReadingRouteImport } from './routes/dream-reading'
import { Route as DreamReflectionsRouteImport } from './routes/dream-reflections'
import { Route as DreamsRouteImport } from './routes/dreams'
import { Route as EarningsRouteImport } from './routes/earnings'
import { Route as EftFlashcardsRouteImport } from './routes/eft-flashcards'
import { Route as EnterpriseRouteImport } from './routes/enterprise'
import { Route as EscalationPathwayRouteImport } from './routes/escalation-pathway'
import { Route as EulaRouteImport } from './routes/eula'
import { Route as EventsRouteImport } from './routes/events'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as FlashcardsRouteImport } from './routes/flashcards'
import { Route as ForestBathingRouteImport } from './routes/forest-bathing'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as GardeningRouteImport } from './routes/gardening'
import { Route as GovernanceRouteImport } from './routes/governance'
import { Route as GriefLossRouteImport } from './routes/grief-loss'
import { Route as GroundingRouteImport } from './routes/grounding'
import { Route as GuestRouteImport } from './routes/guest'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as GuidedJournalRouteImport } from './routes/guided-journal'
import { Route as HalloweenRouteImport } from './routes/halloween'
import { Route as HealingJourneysRouteImport } from './routes/healing-journeys'
import { Route as HelpRouteImport } from './routes/help'
import { Route as HolisticWellbeingRouteImport } from './routes/holistic-wellbeing'
import { Route as HowAreYouFeelingRouteImport } from './routes/how-are-you-feeling'
import { Route as HowToStartRouteImport } from './routes/how-to-start'
import { Route as InnerChildRouteImport } from './routes/inner-child'
import { Route as InstagramAccessRouteImport } from './routes/instagram-access'
import { Route as JoinCommunityRouteImport } from './routes/join-community'
import { Route as JournalRouteImport } from './routes/journal'
import { Route as JournalHomeRouteImport } from './routes/journal-home'
import { Route as JournalReadingRouteImport } from './routes/journal-reading'
import { Route as JournalsRouteImport } from './routes/journals'
import { Route as KnowYourPatternsRouteImport } from './routes/know-your-patterns'
import { Route as LearnRouteImport } from './routes/learn'
import { Route as LiveSessionsSurveyRouteImport } from './routes/live-sessions-survey'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MeditationsRouteImport } from './routes/meditations'
import { Route as MemberSupportRouteImport } from './routes/member-support'
import { Route as MemberWelcomeRouteImport } from './routes/member-welcome'
import { Route as MembershipRouteImport } from './routes/membership'
import { Route as MembershipBenefitsRouteImport } from './routes/membership-benefits'
import { Route as MembershipJourneyRouteImport } from './routes/membership-journey'
import { Route as MoodRouteImport } from './routes/mood'
import { Route as MusicJournalRouteImport } from './routes/music-journal'
import { Route as MyEventsRouteImport } from './routes/my-events'
import { Route as MyHealingJourneyRouteImport } from './routes/my-healing-journey'
import { Route as MyMembershipRouteImport } from './routes/my-membership'
import { Route as MySavedWorkRouteImport } from './routes/my-saved-work'
import { Route as NatureConnectionRouteImport } from './routes/nature-connection'
import { Route as NervousSystemResetRouteImport } from './routes/nervous-system-reset'
import { Route as OctoberRouteImport } from './routes/october'
import { Route as PaymentHistoryRouteImport } from './routes/payment-history'
import { Route as PersonaliseRouteImport } from './routes/personalise'
import { Route as PlanChangeRouteImport } from './routes/plan-change'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as PreferencesRouteImport } from './routes/preferences'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as QuickResetsRouteImport } from './routes/quick-resets'
import { Route as QuizRouteImport } from './routes/quiz'
import { Route as RbDiscRouteImport } from './routes/rb-disc'
import { Route as RecoveryBoardRouteImport } from './routes/recovery-board'
import { Route as RedeemRouteImport } from './routes/redeem'
import { Route as RedeemGiftRouteImport } from './routes/redeem-gift'
import { Route as RegisterMembershipRouteImport } from './routes/register-membership'
import { Route as RegulationCompassRouteImport } from './routes/regulation-compass'
import { Route as RelaxationPracticesRouteImport } from './routes/relaxation-practices'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as RoadmapRouteImport } from './routes/roadmap'
import { Route as SafetyStabilisationRouteImport } from './routes/safety-stabilisation'
import { Route as SanctuaryRouteImport } from './routes/sanctuary'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as SelfCareCalendarRouteImport } from './routes/self-care-calendar'
import { Route as SelfLoveRouteImport } from './routes/self-love'
import { Route as ShadowJourneyRouteImport } from './routes/shadow-journey'
import { Route as ShadowWorkRouteImport } from './routes/shadow-work'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SleepRouteImport } from './routes/sleep'
import { Route as SleepDreamsRouteImport } from './routes/sleep-dreams'
import { Route as SomaticRouteImport } from './routes/somatic'
import { Route as SoundsRouteImport } from './routes/sounds'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TappingRouteImport } from './routes/tapping'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as TherapistApplicationRouteImport } from './routes/therapist-application'
import { Route as TherapistDirectoryRouteImport } from './routes/therapist-directory'
import { Route as TherapistTermsRouteImport } from './routes/therapist-terms'
import { Route as TherapistsRouteImport } from './routes/therapists'
import { Route as TherapyApproachesRouteImport } from './routes/therapy-approaches'
import { Route as ToolkitRouteImport } from './routes/toolkit'
import { Route as TraumaResponseCheckInRouteImport } from './routes/trauma-response-check-in'
import { Route as TraumaResponseWheelRouteImport } from './routes/trauma-response-wheel'
import { Route as TriggerJournalRouteImport } from './routes/trigger-journal'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as UsPrivacyRightsRouteImport } from './routes/us-privacy-rights'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as WorkbooksRouteImport } from './routes/workbooks'
import { Route as WorkshopSignupRouteImport } from './routes/workshop-signup'
import { Route as YogaRouteImport } from './routes/yoga'
import { Route as YoureInRouteImport } from './routes/youre-in'
import { Route as AccountDevicesRouteImport } from './routes/account.devices'
import { Route as AccountPrivacyRouteImport } from './routes/account.privacy'
import { Route as AdminAccessAuditRouteImport } from './routes/admin_.access-audit'
import { Route as AdminAudioHealthRouteImport } from './routes/admin_.audio-health'
import { Route as AdminBlogRouteImport } from './routes/admin_.blog'
import { Route as AdminBoardCardsRouteImport } from './routes/admin_.board-cards'
import { Route as AdminBreakingFreeRouteImport } from './routes/admin_.breaking-free'
import { Route as AdminBroadcastsRouteImport } from './routes/admin_.broadcasts'
import { Route as AdminConfirmTestUserRouteImport } from './routes/admin_.confirm-test-user'
import { Route as AdminContentUpdatesRouteImport } from './routes/admin_.content-updates'
import { Route as AdminContractsRouteImport } from './routes/admin_.contracts'
import { Route as AdminCrisisAlertsRouteImport } from './routes/admin_.crisis-alerts'
import { Route as AdminDnsCheckRouteImport } from './routes/admin_.dns-check'
import { Route as AdminEmailReviewRouteImport } from './routes/admin_.email-review'
import { Route as AdminEscalationCasesRouteImport } from './routes/admin_.escalation-cases'
import { Route as AdminEscalationPathwayRouteImport } from './routes/admin_.escalation-pathway'
import { Route as AdminEventsCalendarRouteImport } from './routes/admin_.events-calendar'
import { Route as AdminFeatureFlagsRouteImport } from './routes/admin_.feature-flags'
import { Route as AdminHalloweenTrackingRouteImport } from './routes/admin_.halloween-tracking'
import { Route as AdminHealthMonitorRouteImport } from './routes/admin_.health-monitor'
import { Route as AdminInvoicesRouteImport } from './routes/admin_.invoices'
import { Route as AdminIssuesRouteImport } from './routes/admin_.issues'
import { Route as AdminLaunchReadinessRouteImport } from './routes/admin_.launch-readiness'
import { Route as AdminLeadConversionRouteImport } from './routes/admin_.lead-conversion'
import { Route as AdminLibraryRouteImport } from './routes/admin_.library'
import { Route as AdminMembersRouteImport } from './routes/admin_.members'
import { Route as AdminMembershipRouteImport } from './routes/admin_.membership'
import { Route as AdminNotificationsRouteImport } from './routes/admin_.notifications'
import { Route as AdminOwnershipPortabilityRouteImport } from './routes/admin_.ownership-portability'
import { Route as AdminPaypalRouteImport } from './routes/admin_.paypal'
import { Route as AdminQueryLogRouteImport } from './routes/admin_.query-log'
import { Route as AdminQuestionsRouteImport } from './routes/admin_.questions'
import { Route as AdminSanctuaryRouteImport } from './routes/admin_.sanctuary'
import { Route as AdminSecureWithinRouteImport } from './routes/admin_.secure-within'
import { Route as AdminShopRouteImport } from './routes/admin_.shop'
import { Route as AdminStripeOpsRouteImport } from './routes/admin_.stripe-ops'
import { Route as AdminStripeTestChecklistRouteImport } from './routes/admin_.stripe-test-checklist'
import { Route as AdminSupportInboxRouteImport } from './routes/admin_.support-inbox'
import { Route as AdminTeamRolesRouteImport } from './routes/admin_.team-roles'
import { Route as AdminTherapistApplicationsRouteImport } from './routes/admin_.therapist-applications'
import { Route as AdminTherapistDirectoryRouteImport } from './routes/admin_.therapist-directory'
import { Route as AdminTherapistEventsRouteImport } from './routes/admin_.therapist-events'
import { Route as AdminWaitlistRouteImport } from './routes/admin_.waitlist'
import { Route as AdminWebhooksRouteImport } from './routes/admin_.webhooks'
import { Route as AnswersIndexRouteImport } from './routes/answers.index'
import { Route as AnswersSlugRouteImport } from './routes/answers.$slug'
import { Route as AuthIndexRouteImport } from './routes/auth.index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BreakingFreeIndexRouteImport } from './routes/breaking-free.index'
import { Route as BreakingFreeJourneyRouteImport } from './routes/breaking-free.journey'
import { Route as CheckoutCancelledRouteImport } from './routes/checkout.cancelled'
import { Route as CheckoutCompleteRouteImport } from './routes/checkout.complete'
import { Route as CheckoutFailedRouteImport } from './routes/checkout.failed'
import { Route as CheckoutGuestRouteImport } from './routes/checkout.guest'
import { Route as CheckoutPassRouteImport } from './routes/checkout.pass'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout.success'
import { Route as EftFlashcardsSlugRouteImport } from './routes/eft-flashcards_.$slug'
import { Route as EventsSlugRouteImport } from './routes/events_.$slug'
import { Route as EventsCalendarRouteImport } from './routes/events_.calendar'
import { Route as GuestTourRouteImport } from './routes/guest.tour'
import { Route as HalloweenDecksRouteImport } from './routes/halloween_.decks'
import { Route as HalloweenJournalRouteImport } from './routes/halloween_.journal'
import { Route as HowAreYouFeelingIndexRouteImport } from './routes/how-are-you-feeling.index'
import { Route as HowAreYouFeelingFeelingRouteImport } from './routes/how-are-you-feeling.$feeling'
import { Route as IntegrateComfortCollectionsRouteImport } from './routes/integrate.comfort-collections'
import { Route as IntegrateFindingAweRouteImport } from './routes/integrate.finding-awe'
import { Route as IntegrateHiddenStrengthsRouteImport } from './routes/integrate.hidden-strengths'
import { Route as IntegrateLettersNeverSentRouteImport } from './routes/integrate.letters-never-sent'
import { Route as IntegrateLifeWorthLivingRouteImport } from './routes/integrate.life-worth-living'
import { Route as IntegrateMicroAdventuresRouteImport } from './routes/integrate.micro-adventures'
import { Route as IntegrateSelfLeadershipRouteImport } from './routes/integrate.self-leadership'
import { Route as IntegrateTheRecoveryHomeRouteImport } from './routes/integrate.the-recovery-home'
import { Route as IntegrateTriggersAsTeachersRouteImport } from './routes/integrate.triggers-as-teachers'
import { Route as IntegrateYourInnerTeamRouteImport } from './routes/integrate.your-inner-team'
import { Route as LearnIndexRouteImport } from './routes/learn.index'
import { Route as LearnCbtRouteImport } from './routes/learn.cbt'
import { Route as LearnDbtRouteImport } from './routes/learn.dbt'
import { Route as LearnDepressionRouteImport } from './routes/learn.depression'
import { Route as LearnGlossaryRouteImport } from './routes/learn.glossary'
import { Route as LearnPersonalityRouteImport } from './routes/learn.personality'
import { Route as LearnPolyvagalLadderRouteImport } from './routes/learn.polyvagal-ladder'
import { Route as LearnSelfHarmSupportRouteImport } from './routes/learn.self-harm-support'
import { Route as LearnShameBasedTraumaRouteImport } from './routes/learn.shame-based-trauma'
import { Route as LearnWhatIsIfsRouteImport } from './routes/learn.what-is-ifs'
import { Route as LearnWindowOfToleranceRouteImport } from './routes/learn.window-of-tolerance'
import { Route as LibraryIndexRouteImport } from './routes/library.index'
import { Route as LibrarySlugRouteImport } from './routes/library.$slug'
import { Route as LibraryHalloweenGroundingRouteImport } from './routes/library.halloween-grounding'
import { Route as LibraryTeenBoundariesWorkbookRouteImport } from './routes/library.teen-boundaries-workbook'
import { Route as PaypalReturnRouteImport } from './routes/paypal.return'
import { Route as RetentionTokenRouteImport } from './routes/retention.$token'
import { Route as SecureWithinIndexRouteImport } from './routes/secure-within.index'
import { Route as SecureWithinJourneyRouteImport } from './routes/secure-within.journey'
import { Route as SettingsAccessibilityRouteImport } from './routes/settings.accessibility'
import { Route as SettingsEmailPreferencesRouteImport } from './routes/settings.email-preferences'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as ShopSlugRouteImport } from './routes/shop.$slug'
import { Route as ShopDownloadsRouteImport } from './routes/shop.downloads'
import { Route as ShopGiftThanksRouteImport } from './routes/shop.gift-thanks'
import { Route as ShopSuccessRouteImport } from './routes/shop.success'
import { Route as SomaticPracticeRouteImport } from './routes/somatic_.$practice'
import { Route as TherapistAvailabilityTokenRouteImport } from './routes/therapist-availability.$token'
import { Route as TherapistsTherapistIdRouteImport } from './routes/therapists_.$therapistId'
import { Route as AdminBroadcastsIdRouteImport } from './routes/admin_.broadcasts_.$id'
import { Route as AdminContractsIndexRouteImport } from './routes/admin_.contracts.index'
import { Route as AdminContractsIdRouteImport } from './routes/admin_.contracts.$id'
import { Route as AdminContractsNewRouteImport } from './routes/admin_.contracts.new'
import { Route as AdminContractsTemplatesRouteImport } from './routes/admin_.contracts.templates'
import { Route as AdminPaypalOpsRouteImport } from './routes/admin_.paypal.ops'
import { Route as AdminPaypalReplayRouteImport } from './routes/admin_.paypal.replay'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin_.users.$userId'
import { Route as BlogCategoryCategoryRouteImport } from './routes/blog.category.$category'
import { Route as BreakingFreeDayDayRouteImport } from './routes/breaking-free.day.$day'
import { Route as BreathingCoreSlugRouteImport } from './routes/breathing.core.$slug'
import { Route as GiftVoucherCodeRouteImport } from './routes/gift.voucher.$code'
import { Route as LearnTopicIndexRouteImport } from './routes/learn.$topic.index'
import { Route as LearnAssessmentsIndexRouteImport } from './routes/learn.assessments.index'
import { Route as LearnAssessmentsSlugRouteImport } from './routes/learn.assessments.$slug'
import { Route as LearnAssessmentsAZRouteImport } from './routes/learn.assessments.a-z'
import { Route as LearnAssessmentsTraumaHealingJourneyRouteImport } from './routes/learn.assessments.trauma-healing-journey'
import { Route as LearnCbtIndexRouteImport } from './routes/learn.cbt.index'
import { Route as LearnCbtModuleRouteImport } from './routes/learn.cbt.$module'
import { Route as LearnDbtIndexRouteImport } from './routes/learn.dbt.index'
import { Route as LearnDbtModuleRouteImport } from './routes/learn.dbt.$module'
import { Route as LearnMenAndTraumaIndexRouteImport } from './routes/learn.men-and-trauma.index'
import { Route as LearnMenAndTraumaSlugRouteImport } from './routes/learn.men-and-trauma.$slug'
import { Route as LearnMenAndTraumaCheckInRouteImport } from './routes/learn.men-and-trauma.check-in'
import { Route as LearnMenAndTraumaToolsRouteImport } from './routes/learn.men-and-trauma.tools'
import { Route as LearnPersonalityIndexRouteImport } from './routes/learn.personality.index'
import { Route as LearnTherapiesIndexRouteImport } from './routes/learn.therapies.index'
import { Route as LearnTherapiesSlugRouteImport } from './routes/learn.therapies.$slug'
import { Route as LearnTherapiesAssessmentRouteImport } from './routes/learn.therapies.assessment'
import { Route as SecureWithinDayDayRouteImport } from './routes/secure-within.day.$day'
import { Route as ShopCategoryCategoryRouteImport } from './routes/shop.category.$category'
import { Route as SignContractTokenRouteImport } from './routes/sign.contract.$token'
import { Route as AdminBroadcastsIdDeliveryRouteImport } from './routes/admin_.broadcasts_.$id.delivery'
import { Route as LearnTopicSectionIndexRouteImport } from './routes/learn.$topic.$section.index'
import { Route as LearnTopicSectionResourceRouteImport } from './routes/learn.$topic.$section.$resource'
import { Route as LearnAssessmentsPioneersIndexRouteImport } from './routes/learn.assessments.pioneers.index'
import { Route as LearnAssessmentsPioneersSlugRouteImport } from './routes/learn.assessments.pioneers.$slug'
import { Route as LearnCbtModuleIndexRouteImport } from './routes/learn.cbt.$module.index'
import { Route as LearnCbtModuleSkillRouteImport } from './routes/learn.cbt.$module.$skill'
import { Route as LearnDbtModuleIndexRouteImport } from './routes/learn.dbt.$module.index'
import { Route as LearnDbtModuleSkillRouteImport } from './routes/learn.dbt.$module.$skill'
import { Route as LearnMenAndTraumaToolsToolShopRouteImport } from './routes/learn.men-and-trauma.tools_.tool-shop'
import { Route as LearnPersonalityDisordersSlugRouteImport } from './routes/learn.personality.disorders.$slug'
import { Route as LearnPersonalityGuidesSlugRouteImport } from './routes/learn.personality.guides.$slug'
import { Route as LearnPersonalityReflectionsSlugRouteImport } from './routes/learn.personality.reflections.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AbuseJournalRoute = AbuseJournalRouteImport.update({
            id: '/abuse-journal',path: '/abuse-journal',getParentRoute: () => rootRouteImport
          })
const AccountCreatedRoute = AccountCreatedRouteImport.update({
            id: '/account-created',path: '/account-created',getParentRoute: () => rootRouteImport
          })
const ActsOfSelfCareRoute = ActsOfSelfCareRouteImport.update({
            id: '/acts-of-self-care',path: '/acts-of-self-care',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin-login',path: '/admin-login',getParentRoute: () => rootRouteImport
          })
const AdminTestimonialsRoute = AdminTestimonialsRouteImport.update({
            id: '/admin-testimonials',path: '/admin-testimonials',getParentRoute: () => rootRouteImport
          })
const AffirmationsRoute = AffirmationsRouteImport.update({
            id: '/affirmations',path: '/affirmations',getParentRoute: () => rootRouteImport
          })
const AiDisclaimerRoute = AiDisclaimerRouteImport.update({
            id: '/ai-disclaimer',path: '/ai-disclaimer',getParentRoute: () => rootRouteImport
          })
const AppMembershipRoute = AppMembershipRouteImport.update({
            id: '/app-membership',path: '/app-membership',getParentRoute: () => rootRouteImport
          })
const AromatherapyRoute = AromatherapyRouteImport.update({
            id: '/aromatherapy',path: '/aromatherapy',getParentRoute: () => rootRouteImport
          })
const ArtBoardRoute = ArtBoardRouteImport.update({
            id: '/art-board',path: '/art-board',getParentRoute: () => rootRouteImport
          })
const BilateralRoute = BilateralRouteImport.update({
            id: '/bilateral',path: '/bilateral',getParentRoute: () => rootRouteImport
          })
const BillingRoute = BillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => rootRouteImport
          })
const BrandColorsRoute = BrandColorsRouteImport.update({
            id: '/brand-colors',path: '/brand-colors',getParentRoute: () => rootRouteImport
          })
const BreathingRoute = BreathingRouteImport.update({
            id: '/breathing',path: '/breathing',getParentRoute: () => rootRouteImport
          })
const CbtThoughtCardsRoute = CbtThoughtCardsRouteImport.update({
            id: '/cbt-thought-cards',path: '/cbt-thought-cards',getParentRoute: () => rootRouteImport
          })
const CheckInRoute = CheckInRouteImport.update({
            id: '/check-in',path: '/check-in',getParentRoute: () => rootRouteImport
          })
const CheckinUnsubscribeRoute = CheckinUnsubscribeRouteImport.update({
            id: '/checkin-unsubscribe',path: '/checkin-unsubscribe',getParentRoute: () => rootRouteImport
          })
const ChooseMembershipRoute = ChooseMembershipRouteImport.update({
            id: '/choose-membership',path: '/choose-membership',getParentRoute: () => rootRouteImport
          })
const ComingSoonRoute = ComingSoonRouteImport.update({
            id: '/coming-soon',path: '/coming-soon',getParentRoute: () => rootRouteImport
          })
const CommunityRoute = CommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => rootRouteImport
          })
const CommunityGuidelinesRoute = CommunityGuidelinesRouteImport.update({
            id: '/community-guidelines',path: '/community-guidelines',getParentRoute: () => rootRouteImport
          })
const CompleteMembershipRoute = CompleteMembershipRouteImport.update({
            id: '/complete-membership',path: '/complete-membership',getParentRoute: () => rootRouteImport
          })
const ConfirmSubscriptionRoute = ConfirmSubscriptionRouteImport.update({
            id: '/confirm-subscription',path: '/confirm-subscription',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const CoursesRoute = CoursesRouteImport.update({
            id: '/courses',path: '/courses',getParentRoute: () => rootRouteImport
          })
const CreativeExpressionRoute = CreativeExpressionRouteImport.update({
            id: '/creative-expression',path: '/creative-expression',getParentRoute: () => rootRouteImport
          })
const CreativeReflectionRoute = CreativeReflectionRouteImport.update({
            id: '/creative-reflection',path: '/creative-reflection',getParentRoute: () => rootRouteImport
          })
const CrisisRoute = CrisisRouteImport.update({
            id: '/crisis',path: '/crisis',getParentRoute: () => rootRouteImport
          })
const DailyPracticeRoute = DailyPracticeRouteImport.update({
            id: '/daily-practice',path: '/daily-practice',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DbtSkillsRoute = DbtSkillsRouteImport.update({
            id: '/dbt-skills',path: '/dbt-skills',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const DissociationJournalRoute = DissociationJournalRouteImport.update({
            id: '/dissociation-journal',path: '/dissociation-journal',getParentRoute: () => rootRouteImport
          })
const DreamReadingRoute = DreamReadingRouteImport.update({
            id: '/dream-reading',path: '/dream-reading',getParentRoute: () => rootRouteImport
          })
const DreamReflectionsRoute = DreamReflectionsRouteImport.update({
            id: '/dream-reflections',path: '/dream-reflections',getParentRoute: () => rootRouteImport
          })
const DreamsRoute = DreamsRouteImport.update({
            id: '/dreams',path: '/dreams',getParentRoute: () => rootRouteImport
          })
const EarningsRoute = EarningsRouteImport.update({
            id: '/earnings',path: '/earnings',getParentRoute: () => rootRouteImport
          })
const EftFlashcardsRoute = EftFlashcardsRouteImport.update({
            id: '/eft-flashcards',path: '/eft-flashcards',getParentRoute: () => rootRouteImport
          })
const EnterpriseRoute = EnterpriseRouteImport.update({
            id: '/enterprise',path: '/enterprise',getParentRoute: () => rootRouteImport
          })
const EscalationPathwayRoute = EscalationPathwayRouteImport.update({
            id: '/escalation-pathway',path: '/escalation-pathway',getParentRoute: () => rootRouteImport
          })
const EulaRoute = EulaRouteImport.update({
            id: '/eula',path: '/eula',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const ExploreRoute = ExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FavoritesRoute = FavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => rootRouteImport
          })
const FlashcardsRoute = FlashcardsRouteImport.update({
            id: '/flashcards',path: '/flashcards',getParentRoute: () => rootRouteImport
          })
const ForestBathingRoute = ForestBathingRouteImport.update({
            id: '/forest-bathing',path: '/forest-bathing',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const GardeningRoute = GardeningRouteImport.update({
            id: '/gardening',path: '/gardening',getParentRoute: () => rootRouteImport
          })
const GovernanceRoute = GovernanceRouteImport.update({
            id: '/governance',path: '/governance',getParentRoute: () => rootRouteImport
          })
const GriefLossRoute = GriefLossRouteImport.update({
            id: '/grief-loss',path: '/grief-loss',getParentRoute: () => rootRouteImport
          })
const GroundingRoute = GroundingRouteImport.update({
            id: '/grounding',path: '/grounding',getParentRoute: () => rootRouteImport
          })
const GuestRoute = GuestRouteImport.update({
            id: '/guest',path: '/guest',getParentRoute: () => rootRouteImport
          })
const GuideRoute = GuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => rootRouteImport
          })
const GuidedJournalRoute = GuidedJournalRouteImport.update({
            id: '/guided-journal',path: '/guided-journal',getParentRoute: () => rootRouteImport
          })
const HalloweenRoute = HalloweenRouteImport.update({
            id: '/halloween',path: '/halloween',getParentRoute: () => rootRouteImport
          })
const HealingJourneysRoute = HealingJourneysRouteImport.update({
            id: '/healing-journeys',path: '/healing-journeys',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const HolisticWellbeingRoute = HolisticWellbeingRouteImport.update({
            id: '/holistic-wellbeing',path: '/holistic-wellbeing',getParentRoute: () => rootRouteImport
          })
const HowAreYouFeelingRoute = HowAreYouFeelingRouteImport.update({
            id: '/how-are-you-feeling',path: '/how-are-you-feeling',getParentRoute: () => rootRouteImport
          })
const HowToStartRoute = HowToStartRouteImport.update({
            id: '/how-to-start',path: '/how-to-start',getParentRoute: () => rootRouteImport
          })
const InnerChildRoute = InnerChildRouteImport.update({
            id: '/inner-child',path: '/inner-child',getParentRoute: () => rootRouteImport
          })
const InstagramAccessRoute = InstagramAccessRouteImport.update({
            id: '/instagram-access',path: '/instagram-access',getParentRoute: () => rootRouteImport
          })
const JoinCommunityRoute = JoinCommunityRouteImport.update({
            id: '/join-community',path: '/join-community',getParentRoute: () => rootRouteImport
          })
const JournalRoute = JournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => rootRouteImport
          })
const JournalHomeRoute = JournalHomeRouteImport.update({
            id: '/journal-home',path: '/journal-home',getParentRoute: () => rootRouteImport
          })
const JournalReadingRoute = JournalReadingRouteImport.update({
            id: '/journal-reading',path: '/journal-reading',getParentRoute: () => rootRouteImport
          })
const JournalsRoute = JournalsRouteImport.update({
            id: '/journals',path: '/journals',getParentRoute: () => rootRouteImport
          })
const KnowYourPatternsRoute = KnowYourPatternsRouteImport.update({
            id: '/know-your-patterns',path: '/know-your-patterns',getParentRoute: () => rootRouteImport
          })
const LearnRoute = LearnRouteImport.update({
            id: '/learn',path: '/learn',getParentRoute: () => rootRouteImport
          })
const LiveSessionsSurveyRoute = LiveSessionsSurveyRouteImport.update({
            id: '/live-sessions-survey',path: '/live-sessions-survey',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MeditationsRoute = MeditationsRouteImport.update({
            id: '/meditations',path: '/meditations',getParentRoute: () => rootRouteImport
          })
const MemberSupportRoute = MemberSupportRouteImport.update({
            id: '/member-support',path: '/member-support',getParentRoute: () => rootRouteImport
          })
const MemberWelcomeRoute = MemberWelcomeRouteImport.update({
            id: '/member-welcome',path: '/member-welcome',getParentRoute: () => rootRouteImport
          })
const MembershipRoute = MembershipRouteImport.update({
            id: '/membership',path: '/membership',getParentRoute: () => rootRouteImport
          })
const MembershipBenefitsRoute = MembershipBenefitsRouteImport.update({
            id: '/membership-benefits',path: '/membership-benefits',getParentRoute: () => rootRouteImport
          })
const MembershipJourneyRoute = MembershipJourneyRouteImport.update({
            id: '/membership-journey',path: '/membership-journey',getParentRoute: () => rootRouteImport
          })
const MoodRoute = MoodRouteImport.update({
            id: '/mood',path: '/mood',getParentRoute: () => rootRouteImport
          })
const MusicJournalRoute = MusicJournalRouteImport.update({
            id: '/music-journal',path: '/music-journal',getParentRoute: () => rootRouteImport
          })
const MyEventsRoute = MyEventsRouteImport.update({
            id: '/my-events',path: '/my-events',getParentRoute: () => rootRouteImport
          })
const MyHealingJourneyRoute = MyHealingJourneyRouteImport.update({
            id: '/my-healing-journey',path: '/my-healing-journey',getParentRoute: () => rootRouteImport
          })
const MyMembershipRoute = MyMembershipRouteImport.update({
            id: '/my-membership',path: '/my-membership',getParentRoute: () => rootRouteImport
          })
const MySavedWorkRoute = MySavedWorkRouteImport.update({
            id: '/my-saved-work',path: '/my-saved-work',getParentRoute: () => rootRouteImport
          })
const NatureConnectionRoute = NatureConnectionRouteImport.update({
            id: '/nature-connection',path: '/nature-connection',getParentRoute: () => rootRouteImport
          })
const NervousSystemResetRoute = NervousSystemResetRouteImport.update({
            id: '/nervous-system-reset',path: '/nervous-system-reset',getParentRoute: () => rootRouteImport
          })
const OctoberRoute = OctoberRouteImport.update({
            id: '/october',path: '/october',getParentRoute: () => rootRouteImport
          })
const PaymentHistoryRoute = PaymentHistoryRouteImport.update({
            id: '/payment-history',path: '/payment-history',getParentRoute: () => rootRouteImport
          })
const PersonaliseRoute = PersonaliseRouteImport.update({
            id: '/personalise',path: '/personalise',getParentRoute: () => rootRouteImport
          })
const PlanChangeRoute = PlanChangeRouteImport.update({
            id: '/plan-change',path: '/plan-change',getParentRoute: () => rootRouteImport
          })
const PortalRoute = PortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => rootRouteImport
          })
const PreferencesRoute = PreferencesRouteImport.update({
            id: '/preferences',path: '/preferences',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const QuickResetsRoute = QuickResetsRouteImport.update({
            id: '/quick-resets',path: '/quick-resets',getParentRoute: () => rootRouteImport
          })
const QuizRoute = QuizRouteImport.update({
            id: '/quiz',path: '/quiz',getParentRoute: () => rootRouteImport
          })
const RbDiscRoute = RbDiscRouteImport.update({
            id: '/rb-disc',path: '/rb-disc',getParentRoute: () => rootRouteImport
          })
const RecoveryBoardRoute = RecoveryBoardRouteImport.update({
            id: '/recovery-board',path: '/recovery-board',getParentRoute: () => rootRouteImport
          })
const RedeemRoute = RedeemRouteImport.update({
            id: '/redeem',path: '/redeem',getParentRoute: () => rootRouteImport
          })
const RedeemGiftRoute = RedeemGiftRouteImport.update({
            id: '/redeem-gift',path: '/redeem-gift',getParentRoute: () => rootRouteImport
          })
const RegisterMembershipRoute = RegisterMembershipRouteImport.update({
            id: '/register-membership',path: '/register-membership',getParentRoute: () => rootRouteImport
          })
const RegulationCompassRoute = RegulationCompassRouteImport.update({
            id: '/regulation-compass',path: '/regulation-compass',getParentRoute: () => rootRouteImport
          })
const RelaxationPracticesRoute = RelaxationPracticesRouteImport.update({
            id: '/relaxation-practices',path: '/relaxation-practices',getParentRoute: () => rootRouteImport
          })
const ResetRoute = ResetRouteImport.update({
            id: '/reset',path: '/reset',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const RoadmapRoute = RoadmapRouteImport.update({
            id: '/roadmap',path: '/roadmap',getParentRoute: () => rootRouteImport
          })
const SafetyStabilisationRoute = SafetyStabilisationRouteImport.update({
            id: '/safety-stabilisation',path: '/safety-stabilisation',getParentRoute: () => rootRouteImport
          })
const SanctuaryRoute = SanctuaryRouteImport.update({
            id: '/sanctuary',path: '/sanctuary',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const SelfCareCalendarRoute = SelfCareCalendarRouteImport.update({
            id: '/self-care-calendar',path: '/self-care-calendar',getParentRoute: () => rootRouteImport
          })
const SelfLoveRoute = SelfLoveRouteImport.update({
            id: '/self-love',path: '/self-love',getParentRoute: () => rootRouteImport
          })
const ShadowJourneyRoute = ShadowJourneyRouteImport.update({
            id: '/shadow-journey',path: '/shadow-journey',getParentRoute: () => rootRouteImport
          })
const ShadowWorkRoute = ShadowWorkRouteImport.update({
            id: '/shadow-work',path: '/shadow-work',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SleepRoute = SleepRouteImport.update({
            id: '/sleep',path: '/sleep',getParentRoute: () => rootRouteImport
          })
const SleepDreamsRoute = SleepDreamsRouteImport.update({
            id: '/sleep-dreams',path: '/sleep-dreams',getParentRoute: () => rootRouteImport
          })
const SomaticRoute = SomaticRouteImport.update({
            id: '/somatic',path: '/somatic',getParentRoute: () => rootRouteImport
          })
const SoundsRoute = SoundsRouteImport.update({
            id: '/sounds',path: '/sounds',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const TappingRoute = TappingRouteImport.update({
            id: '/tapping',path: '/tapping',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TestimonialsRoute = TestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => rootRouteImport
          })
const TherapistApplicationRoute = TherapistApplicationRouteImport.update({
            id: '/therapist-application',path: '/therapist-application',getParentRoute: () => rootRouteImport
          })
const TherapistDirectoryRoute = TherapistDirectoryRouteImport.update({
            id: '/therapist-directory',path: '/therapist-directory',getParentRoute: () => rootRouteImport
          })
const TherapistTermsRoute = TherapistTermsRouteImport.update({
            id: '/therapist-terms',path: '/therapist-terms',getParentRoute: () => rootRouteImport
          })
const TherapistsRoute = TherapistsRouteImport.update({
            id: '/therapists',path: '/therapists',getParentRoute: () => rootRouteImport
          })
const TherapyApproachesRoute = TherapyApproachesRouteImport.update({
            id: '/therapy-approaches',path: '/therapy-approaches',getParentRoute: () => rootRouteImport
          })
const ToolkitRoute = ToolkitRouteImport.update({
            id: '/toolkit',path: '/toolkit',getParentRoute: () => rootRouteImport
          })
const TraumaResponseCheckInRoute = TraumaResponseCheckInRouteImport.update({
            id: '/trauma-response-check-in',path: '/trauma-response-check-in',getParentRoute: () => rootRouteImport
          })
const TraumaResponseWheelRoute = TraumaResponseWheelRouteImport.update({
            id: '/trauma-response-wheel',path: '/trauma-response-wheel',getParentRoute: () => rootRouteImport
          })
const TriggerJournalRoute = TriggerJournalRouteImport.update({
            id: '/trigger-journal',path: '/trigger-journal',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const UsPrivacyRightsRoute = UsPrivacyRightsRouteImport.update({
            id: '/us-privacy-rights',path: '/us-privacy-rights',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const WorkbooksRoute = WorkbooksRouteImport.update({
            id: '/workbooks',path: '/workbooks',getParentRoute: () => rootRouteImport
          })
const WorkshopSignupRoute = WorkshopSignupRouteImport.update({
            id: '/workshop-signup',path: '/workshop-signup',getParentRoute: () => rootRouteImport
          })
const YogaRoute = YogaRouteImport.update({
            id: '/yoga',path: '/yoga',getParentRoute: () => rootRouteImport
          })
const YoureInRoute = YoureInRouteImport.update({
            id: '/youre-in',path: '/youre-in',getParentRoute: () => rootRouteImport
          })
const AccountDevicesRoute = AccountDevicesRouteImport.update({
            id: '/account/devices',path: '/account/devices',getParentRoute: () => rootRouteImport
          })
const AccountPrivacyRoute = AccountPrivacyRouteImport.update({
            id: '/account/privacy',path: '/account/privacy',getParentRoute: () => rootRouteImport
          })
const AdminAccessAuditRoute = AdminAccessAuditRouteImport.update({
            id: '/admin_/access-audit',path: '/admin/access-audit',getParentRoute: () => rootRouteImport
          })
const AdminAudioHealthRoute = AdminAudioHealthRouteImport.update({
            id: '/admin_/audio-health',path: '/admin/audio-health',getParentRoute: () => rootRouteImport
          })
const AdminBlogRoute = AdminBlogRouteImport.update({
            id: '/admin_/blog',path: '/admin/blog',getParentRoute: () => rootRouteImport
          })
const AdminBoardCardsRoute = AdminBoardCardsRouteImport.update({
            id: '/admin_/board-cards',path: '/admin/board-cards',getParentRoute: () => rootRouteImport
          })
const AdminBreakingFreeRoute = AdminBreakingFreeRouteImport.update({
            id: '/admin_/breaking-free',path: '/admin/breaking-free',getParentRoute: () => rootRouteImport
          })
const AdminBroadcastsRoute = AdminBroadcastsRouteImport.update({
            id: '/admin_/broadcasts',path: '/admin/broadcasts',getParentRoute: () => rootRouteImport
          })
const AdminConfirmTestUserRoute = AdminConfirmTestUserRouteImport.update({
            id: '/admin_/confirm-test-user',path: '/admin/confirm-test-user',getParentRoute: () => rootRouteImport
          })
const AdminContentUpdatesRoute = AdminContentUpdatesRouteImport.update({
            id: '/admin_/content-updates',path: '/admin/content-updates',getParentRoute: () => rootRouteImport
          })
const AdminContractsRoute = AdminContractsRouteImport.update({
            id: '/admin_/contracts',path: '/admin/contracts',getParentRoute: () => rootRouteImport
          })
const AdminCrisisAlertsRoute = AdminCrisisAlertsRouteImport.update({
            id: '/admin_/crisis-alerts',path: '/admin/crisis-alerts',getParentRoute: () => rootRouteImport
          })
const AdminDnsCheckRoute = AdminDnsCheckRouteImport.update({
            id: '/admin_/dns-check',path: '/admin/dns-check',getParentRoute: () => rootRouteImport
          })
const AdminEmailReviewRoute = AdminEmailReviewRouteImport.update({
            id: '/admin_/email-review',path: '/admin/email-review',getParentRoute: () => rootRouteImport
          })
const AdminEscalationCasesRoute = AdminEscalationCasesRouteImport.update({
            id: '/admin_/escalation-cases',path: '/admin/escalation-cases',getParentRoute: () => rootRouteImport
          })
const AdminEscalationPathwayRoute = AdminEscalationPathwayRouteImport.update({
            id: '/admin_/escalation-pathway',path: '/admin/escalation-pathway',getParentRoute: () => rootRouteImport
          })
const AdminEventsCalendarRoute = AdminEventsCalendarRouteImport.update({
            id: '/admin_/events-calendar',path: '/admin/events-calendar',getParentRoute: () => rootRouteImport
          })
const AdminFeatureFlagsRoute = AdminFeatureFlagsRouteImport.update({
            id: '/admin_/feature-flags',path: '/admin/feature-flags',getParentRoute: () => rootRouteImport
          })
const AdminHalloweenTrackingRoute = AdminHalloweenTrackingRouteImport.update({
            id: '/admin_/halloween-tracking',path: '/admin/halloween-tracking',getParentRoute: () => rootRouteImport
          })
const AdminHealthMonitorRoute = AdminHealthMonitorRouteImport.update({
            id: '/admin_/health-monitor',path: '/admin/health-monitor',getParentRoute: () => rootRouteImport
          })
const AdminInvoicesRoute = AdminInvoicesRouteImport.update({
            id: '/admin_/invoices',path: '/admin/invoices',getParentRoute: () => rootRouteImport
          })
const AdminIssuesRoute = AdminIssuesRouteImport.update({
            id: '/admin_/issues',path: '/admin/issues',getParentRoute: () => rootRouteImport
          })
const AdminLaunchReadinessRoute = AdminLaunchReadinessRouteImport.update({
            id: '/admin_/launch-readiness',path: '/admin/launch-readiness',getParentRoute: () => rootRouteImport
          })
const AdminLeadConversionRoute = AdminLeadConversionRouteImport.update({
            id: '/admin_/lead-conversion',path: '/admin/lead-conversion',getParentRoute: () => rootRouteImport
          })
const AdminLibraryRoute = AdminLibraryRouteImport.update({
            id: '/admin_/library',path: '/admin/library',getParentRoute: () => rootRouteImport
          })
const AdminMembersRoute = AdminMembersRouteImport.update({
            id: '/admin_/members',path: '/admin/members',getParentRoute: () => rootRouteImport
          })
const AdminMembershipRoute = AdminMembershipRouteImport.update({
            id: '/admin_/membership',path: '/admin/membership',getParentRoute: () => rootRouteImport
          })
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
            id: '/admin_/notifications',path: '/admin/notifications',getParentRoute: () => rootRouteImport
          })
const AdminOwnershipPortabilityRoute = AdminOwnershipPortabilityRouteImport.update({
            id: '/admin_/ownership-portability',path: '/admin/ownership-portability',getParentRoute: () => rootRouteImport
          })
const AdminPaypalRoute = AdminPaypalRouteImport.update({
            id: '/admin_/paypal',path: '/admin/paypal',getParentRoute: () => rootRouteImport
          })
const AdminQueryLogRoute = AdminQueryLogRouteImport.update({
            id: '/admin_/query-log',path: '/admin/query-log',getParentRoute: () => rootRouteImport
          })
const AdminQuestionsRoute = AdminQuestionsRouteImport.update({
            id: '/admin_/questions',path: '/admin/questions',getParentRoute: () => rootRouteImport
          })
const AdminSanctuaryRoute = AdminSanctuaryRouteImport.update({
            id: '/admin_/sanctuary',path: '/admin/sanctuary',getParentRoute: () => rootRouteImport
          })
const AdminSecureWithinRoute = AdminSecureWithinRouteImport.update({
            id: '/admin_/secure-within',path: '/admin/secure-within',getParentRoute: () => rootRouteImport
          })
const AdminShopRoute = AdminShopRouteImport.update({
            id: '/admin_/shop',path: '/admin/shop',getParentRoute: () => rootRouteImport
          })
const AdminStripeOpsRoute = AdminStripeOpsRouteImport.update({
            id: '/admin_/stripe-ops',path: '/admin/stripe-ops',getParentRoute: () => rootRouteImport
          })
const AdminStripeTestChecklistRoute = AdminStripeTestChecklistRouteImport.update({
            id: '/admin_/stripe-test-checklist',path: '/admin/stripe-test-checklist',getParentRoute: () => rootRouteImport
          })
const AdminSupportInboxRoute = AdminSupportInboxRouteImport.update({
            id: '/admin_/support-inbox',path: '/admin/support-inbox',getParentRoute: () => rootRouteImport
          })
const AdminTeamRolesRoute = AdminTeamRolesRouteImport.update({
            id: '/admin_/team-roles',path: '/admin/team-roles',getParentRoute: () => rootRouteImport
          })
const AdminTherapistApplicationsRoute = AdminTherapistApplicationsRouteImport.update({
            id: '/admin_/therapist-applications',path: '/admin/therapist-applications',getParentRoute: () => rootRouteImport
          })
const AdminTherapistDirectoryRoute = AdminTherapistDirectoryRouteImport.update({
            id: '/admin_/therapist-directory',path: '/admin/therapist-directory',getParentRoute: () => rootRouteImport
          })
const AdminTherapistEventsRoute = AdminTherapistEventsRouteImport.update({
            id: '/admin_/therapist-events',path: '/admin/therapist-events',getParentRoute: () => rootRouteImport
          })
const AdminWaitlistRoute = AdminWaitlistRouteImport.update({
            id: '/admin_/waitlist',path: '/admin/waitlist',getParentRoute: () => rootRouteImport
          })
const AdminWebhooksRoute = AdminWebhooksRouteImport.update({
            id: '/admin_/webhooks',path: '/admin/webhooks',getParentRoute: () => rootRouteImport
          })
const AnswersIndexRoute = AnswersIndexRouteImport.update({
            id: '/answers/',path: '/answers/',getParentRoute: () => rootRouteImport
          })
const AnswersSlugRoute = AnswersSlugRouteImport.update({
            id: '/answers/$slug',path: '/answers/$slug',getParentRoute: () => rootRouteImport
          })
const AuthIndexRoute = AuthIndexRouteImport.update({
            id: '/auth/',path: '/auth/',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BreakingFreeIndexRoute = BreakingFreeIndexRouteImport.update({
            id: '/breaking-free/',path: '/breaking-free/',getParentRoute: () => rootRouteImport
          })
const BreakingFreeJourneyRoute = BreakingFreeJourneyRouteImport.update({
            id: '/breaking-free/journey',path: '/breaking-free/journey',getParentRoute: () => rootRouteImport
          })
const CheckoutCancelledRoute = CheckoutCancelledRouteImport.update({
            id: '/checkout/cancelled',path: '/checkout/cancelled',getParentRoute: () => rootRouteImport
          })
const CheckoutCompleteRoute = CheckoutCompleteRouteImport.update({
            id: '/checkout/complete',path: '/checkout/complete',getParentRoute: () => rootRouteImport
          })
const CheckoutFailedRoute = CheckoutFailedRouteImport.update({
            id: '/checkout/failed',path: '/checkout/failed',getParentRoute: () => rootRouteImport
          })
const CheckoutGuestRoute = CheckoutGuestRouteImport.update({
            id: '/checkout/guest',path: '/checkout/guest',getParentRoute: () => rootRouteImport
          })
const CheckoutPassRoute = CheckoutPassRouteImport.update({
            id: '/checkout/pass',path: '/checkout/pass',getParentRoute: () => rootRouteImport
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => rootRouteImport
          })
const EftFlashcardsSlugRoute = EftFlashcardsSlugRouteImport.update({
            id: '/eft-flashcards_/$slug',path: '/eft-flashcards/$slug',getParentRoute: () => rootRouteImport
          })
const EventsSlugRoute = EventsSlugRouteImport.update({
            id: '/events_/$slug',path: '/events/$slug',getParentRoute: () => rootRouteImport
          })
const EventsCalendarRoute = EventsCalendarRouteImport.update({
            id: '/events_/calendar',path: '/events/calendar',getParentRoute: () => rootRouteImport
          })
const GuestTourRoute = GuestTourRouteImport.update({
            id: '/tour',path: '/tour',getParentRoute: () => GuestRoute
          })
const HalloweenDecksRoute = HalloweenDecksRouteImport.update({
            id: '/halloween_/decks',path: '/halloween/decks',getParentRoute: () => rootRouteImport
          })
const HalloweenJournalRoute = HalloweenJournalRouteImport.update({
            id: '/halloween_/journal',path: '/halloween/journal',getParentRoute: () => rootRouteImport
          })
const HowAreYouFeelingIndexRoute = HowAreYouFeelingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HowAreYouFeelingRoute
          })
const HowAreYouFeelingFeelingRoute = HowAreYouFeelingFeelingRouteImport.update({
            id: '/$feeling',path: '/$feeling',getParentRoute: () => HowAreYouFeelingRoute
          })
const IntegrateComfortCollectionsRoute = IntegrateComfortCollectionsRouteImport.update({
            id: '/integrate/comfort-collections',path: '/integrate/comfort-collections',getParentRoute: () => rootRouteImport
          })
const IntegrateFindingAweRoute = IntegrateFindingAweRouteImport.update({
            id: '/integrate/finding-awe',path: '/integrate/finding-awe',getParentRoute: () => rootRouteImport
          })
const IntegrateHiddenStrengthsRoute = IntegrateHiddenStrengthsRouteImport.update({
            id: '/integrate/hidden-strengths',path: '/integrate/hidden-strengths',getParentRoute: () => rootRouteImport
          })
const IntegrateLettersNeverSentRoute = IntegrateLettersNeverSentRouteImport.update({
            id: '/integrate/letters-never-sent',path: '/integrate/letters-never-sent',getParentRoute: () => rootRouteImport
          })
const IntegrateLifeWorthLivingRoute = IntegrateLifeWorthLivingRouteImport.update({
            id: '/integrate/life-worth-living',path: '/integrate/life-worth-living',getParentRoute: () => rootRouteImport
          })
const IntegrateMicroAdventuresRoute = IntegrateMicroAdventuresRouteImport.update({
            id: '/integrate/micro-adventures',path: '/integrate/micro-adventures',getParentRoute: () => rootRouteImport
          })
const IntegrateSelfLeadershipRoute = IntegrateSelfLeadershipRouteImport.update({
            id: '/integrate/self-leadership',path: '/integrate/self-leadership',getParentRoute: () => rootRouteImport
          })
const IntegrateTheRecoveryHomeRoute = IntegrateTheRecoveryHomeRouteImport.update({
            id: '/integrate/the-recovery-home',path: '/integrate/the-recovery-home',getParentRoute: () => rootRouteImport
          })
const IntegrateTriggersAsTeachersRoute = IntegrateTriggersAsTeachersRouteImport.update({
            id: '/integrate/triggers-as-teachers',path: '/integrate/triggers-as-teachers',getParentRoute: () => rootRouteImport
          })
const IntegrateYourInnerTeamRoute = IntegrateYourInnerTeamRouteImport.update({
            id: '/integrate/your-inner-team',path: '/integrate/your-inner-team',getParentRoute: () => rootRouteImport
          })
const LearnIndexRoute = LearnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LearnRoute
          })
const LearnCbtRoute = LearnCbtRouteImport.update({
            id: '/cbt',path: '/cbt',getParentRoute: () => LearnRoute
          })
const LearnDbtRoute = LearnDbtRouteImport.update({
            id: '/dbt',path: '/dbt',getParentRoute: () => LearnRoute
          })
const LearnDepressionRoute = LearnDepressionRouteImport.update({
            id: '/depression',path: '/depression',getParentRoute: () => LearnRoute
          })
const LearnGlossaryRoute = LearnGlossaryRouteImport.update({
            id: '/glossary',path: '/glossary',getParentRoute: () => LearnRoute
          })
const LearnPersonalityRoute = LearnPersonalityRouteImport.update({
            id: '/personality',path: '/personality',getParentRoute: () => LearnRoute
          })
const LearnPolyvagalLadderRoute = LearnPolyvagalLadderRouteImport.update({
            id: '/polyvagal-ladder',path: '/polyvagal-ladder',getParentRoute: () => LearnRoute
          })
const LearnSelfHarmSupportRoute = LearnSelfHarmSupportRouteImport.update({
            id: '/self-harm-support',path: '/self-harm-support',getParentRoute: () => LearnRoute
          })
const LearnShameBasedTraumaRoute = LearnShameBasedTraumaRouteImport.update({
            id: '/shame-based-trauma',path: '/shame-based-trauma',getParentRoute: () => LearnRoute
          })
const LearnWhatIsIfsRoute = LearnWhatIsIfsRouteImport.update({
            id: '/what-is-ifs',path: '/what-is-ifs',getParentRoute: () => LearnRoute
          })
const LearnWindowOfToleranceRoute = LearnWindowOfToleranceRouteImport.update({
            id: '/window-of-tolerance',path: '/window-of-tolerance',getParentRoute: () => LearnRoute
          })
const LibraryIndexRoute = LibraryIndexRouteImport.update({
            id: '/library/',path: '/library/',getParentRoute: () => rootRouteImport
          })
const LibrarySlugRoute = LibrarySlugRouteImport.update({
            id: '/library/$slug',path: '/library/$slug',getParentRoute: () => rootRouteImport
          })
const LibraryHalloweenGroundingRoute = LibraryHalloweenGroundingRouteImport.update({
            id: '/library/halloween-grounding',path: '/library/halloween-grounding',getParentRoute: () => rootRouteImport
          })
const LibraryTeenBoundariesWorkbookRoute = LibraryTeenBoundariesWorkbookRouteImport.update({
            id: '/library/teen-boundaries-workbook',path: '/library/teen-boundaries-workbook',getParentRoute: () => rootRouteImport
          })
const PaypalReturnRoute = PaypalReturnRouteImport.update({
            id: '/paypal/return',path: '/paypal/return',getParentRoute: () => rootRouteImport
          })
const RetentionTokenRoute = RetentionTokenRouteImport.update({
            id: '/retention/$token',path: '/retention/$token',getParentRoute: () => rootRouteImport
          })
const SecureWithinIndexRoute = SecureWithinIndexRouteImport.update({
            id: '/secure-within/',path: '/secure-within/',getParentRoute: () => rootRouteImport
          })
const SecureWithinJourneyRoute = SecureWithinJourneyRouteImport.update({
            id: '/secure-within/journey',path: '/secure-within/journey',getParentRoute: () => rootRouteImport
          })
const SettingsAccessibilityRoute = SettingsAccessibilityRouteImport.update({
            id: '/settings/accessibility',path: '/settings/accessibility',getParentRoute: () => rootRouteImport
          })
const SettingsEmailPreferencesRoute = SettingsEmailPreferencesRouteImport.update({
            id: '/settings/email-preferences',path: '/settings/email-preferences',getParentRoute: () => rootRouteImport
          })
const ShopIndexRoute = ShopIndexRouteImport.update({
            id: '/shop/',path: '/shop/',getParentRoute: () => rootRouteImport
          })
const ShopSlugRoute = ShopSlugRouteImport.update({
            id: '/shop/$slug',path: '/shop/$slug',getParentRoute: () => rootRouteImport
          })
const ShopDownloadsRoute = ShopDownloadsRouteImport.update({
            id: '/shop/downloads',path: '/shop/downloads',getParentRoute: () => rootRouteImport
          })
const ShopGiftThanksRoute = ShopGiftThanksRouteImport.update({
            id: '/shop/gift-thanks',path: '/shop/gift-thanks',getParentRoute: () => rootRouteImport
          })
const ShopSuccessRoute = ShopSuccessRouteImport.update({
            id: '/shop/success',path: '/shop/success',getParentRoute: () => rootRouteImport
          })
const SomaticPracticeRoute = SomaticPracticeRouteImport.update({
            id: '/somatic_/$practice',path: '/somatic/$practice',getParentRoute: () => rootRouteImport
          })
const TherapistAvailabilityTokenRoute = TherapistAvailabilityTokenRouteImport.update({
            id: '/therapist-availability/$token',path: '/therapist-availability/$token',getParentRoute: () => rootRouteImport
          })
const TherapistsTherapistIdRoute = TherapistsTherapistIdRouteImport.update({
            id: '/therapists_/$therapistId',path: '/therapists/$therapistId',getParentRoute: () => rootRouteImport
          })
const AdminBroadcastsIdRoute = AdminBroadcastsIdRouteImport.update({
            id: '/admin_/broadcasts_/$id',path: '/admin/broadcasts/$id',getParentRoute: () => rootRouteImport
          })
const AdminContractsIndexRoute = AdminContractsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminContractsRoute
          })
const AdminContractsIdRoute = AdminContractsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminContractsRoute
          })
const AdminContractsNewRoute = AdminContractsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminContractsRoute
          })
const AdminContractsTemplatesRoute = AdminContractsTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => AdminContractsRoute
          })
const AdminPaypalOpsRoute = AdminPaypalOpsRouteImport.update({
            id: '/ops',path: '/ops',getParentRoute: () => AdminPaypalRoute
          })
const AdminPaypalReplayRoute = AdminPaypalReplayRouteImport.update({
            id: '/replay',path: '/replay',getParentRoute: () => AdminPaypalRoute
          })
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
            id: '/admin_/users/$userId',path: '/admin/users/$userId',getParentRoute: () => rootRouteImport
          })
const BlogCategoryCategoryRoute = BlogCategoryCategoryRouteImport.update({
            id: '/blog/category/$category',path: '/blog/category/$category',getParentRoute: () => rootRouteImport
          })
const BreakingFreeDayDayRoute = BreakingFreeDayDayRouteImport.update({
            id: '/breaking-free/day/$day',path: '/breaking-free/day/$day',getParentRoute: () => rootRouteImport
          })
const BreathingCoreSlugRoute = BreathingCoreSlugRouteImport.update({
            id: '/core/$slug',path: '/core/$slug',getParentRoute: () => BreathingRoute
          })
const GiftVoucherCodeRoute = GiftVoucherCodeRouteImport.update({
            id: '/gift/voucher/$code',path: '/gift/voucher/$code',getParentRoute: () => rootRouteImport
          })
const LearnTopicIndexRoute = LearnTopicIndexRouteImport.update({
            id: '/$topic/',path: '/$topic/',getParentRoute: () => LearnRoute
          })
const LearnAssessmentsIndexRoute = LearnAssessmentsIndexRouteImport.update({
            id: '/assessments/',path: '/assessments/',getParentRoute: () => LearnRoute
          })
const LearnAssessmentsSlugRoute = LearnAssessmentsSlugRouteImport.update({
            id: '/assessments/$slug',path: '/assessments/$slug',getParentRoute: () => LearnRoute
          })
const LearnAssessmentsAZRoute = LearnAssessmentsAZRouteImport.update({
            id: '/assessments/a-z',path: '/assessments/a-z',getParentRoute: () => LearnRoute
          })
const LearnAssessmentsTraumaHealingJourneyRoute = LearnAssessmentsTraumaHealingJourneyRouteImport.update({
            id: '/assessments/trauma-healing-journey',path: '/assessments/trauma-healing-journey',getParentRoute: () => LearnRoute
          })
const LearnCbtIndexRoute = LearnCbtIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LearnCbtRoute
          })
const LearnCbtModuleRoute = LearnCbtModuleRouteImport.update({
            id: '/$module',path: '/$module',getParentRoute: () => LearnCbtRoute
          })
const LearnDbtIndexRoute = LearnDbtIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LearnDbtRoute
          })
const LearnDbtModuleRoute = LearnDbtModuleRouteImport.update({
            id: '/$module',path: '/$module',getParentRoute: () => LearnDbtRoute
          })
const LearnMenAndTraumaIndexRoute = LearnMenAndTraumaIndexRouteImport.update({
            id: '/men-and-trauma/',path: '/men-and-trauma/',getParentRoute: () => LearnRoute
          })
const LearnMenAndTraumaSlugRoute = LearnMenAndTraumaSlugRouteImport.update({
            id: '/men-and-trauma/$slug',path: '/men-and-trauma/$slug',getParentRoute: () => LearnRoute
          })
const LearnMenAndTraumaCheckInRoute = LearnMenAndTraumaCheckInRouteImport.update({
            id: '/men-and-trauma/check-in',path: '/men-and-trauma/check-in',getParentRoute: () => LearnRoute
          })
const LearnMenAndTraumaToolsRoute = LearnMenAndTraumaToolsRouteImport.update({
            id: '/men-and-trauma/tools',path: '/men-and-trauma/tools',getParentRoute: () => LearnRoute
          })
const LearnPersonalityIndexRoute = LearnPersonalityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LearnPersonalityRoute
          })
const LearnTherapiesIndexRoute = LearnTherapiesIndexRouteImport.update({
            id: '/therapies/',path: '/therapies/',getParentRoute: () => LearnRoute
          })
const LearnTherapiesSlugRoute = LearnTherapiesSlugRouteImport.update({
            id: '/therapies/$slug',path: '/therapies/$slug',getParentRoute: () => LearnRoute
          })
const LearnTherapiesAssessmentRoute = LearnTherapiesAssessmentRouteImport.update({
            id: '/therapies/assessment',path: '/therapies/assessment',getParentRoute: () => LearnRoute
          })
const SecureWithinDayDayRoute = SecureWithinDayDayRouteImport.update({
            id: '/secure-within/day/$day',path: '/secure-within/day/$day',getParentRoute: () => rootRouteImport
          })
const ShopCategoryCategoryRoute = ShopCategoryCategoryRouteImport.update({
            id: '/shop/category/$category',path: '/shop/category/$category',getParentRoute: () => rootRouteImport
          })
const SignContractTokenRoute = SignContractTokenRouteImport.update({
            id: '/sign/contract/$token',path: '/sign/contract/$token',getParentRoute: () => rootRouteImport
          })
const AdminBroadcastsIdDeliveryRoute = AdminBroadcastsIdDeliveryRouteImport.update({
            id: '/delivery',path: '/delivery',getParentRoute: () => AdminBroadcastsIdRoute
          })
const LearnTopicSectionIndexRoute = LearnTopicSectionIndexRouteImport.update({
            id: '/$topic/$section/',path: '/$topic/$section/',getParentRoute: () => LearnRoute
          })
const LearnTopicSectionResourceRoute = LearnTopicSectionResourceRouteImport.update({
            id: '/$topic/$section/$resource',path: '/$topic/$section/$resource',getParentRoute: () => LearnRoute
          })
const LearnAssessmentsPioneersIndexRoute = LearnAssessmentsPioneersIndexRouteImport.update({
            id: '/assessments/pioneers/',path: '/assessments/pioneers/',getParentRoute: () => LearnRoute
          })
const LearnAssessmentsPioneersSlugRoute = LearnAssessmentsPioneersSlugRouteImport.update({
            id: '/assessments/pioneers/$slug',path: '/assessments/pioneers/$slug',getParentRoute: () => LearnRoute
          })
const LearnCbtModuleIndexRoute = LearnCbtModuleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LearnCbtModuleRoute
          })
const LearnCbtModuleSkillRoute = LearnCbtModuleSkillRouteImport.update({
            id: '/$skill',path: '/$skill',getParentRoute: () => LearnCbtModuleRoute
          })
const LearnDbtModuleIndexRoute = LearnDbtModuleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LearnDbtModuleRoute
          })
const LearnDbtModuleSkillRoute = LearnDbtModuleSkillRouteImport.update({
            id: '/$skill',path: '/$skill',getParentRoute: () => LearnDbtModuleRoute
          })
const LearnMenAndTraumaToolsToolShopRoute = LearnMenAndTraumaToolsToolShopRouteImport.update({
            id: '/men-and-trauma/tools_/tool-shop',path: '/men-and-trauma/tools/tool-shop',getParentRoute: () => LearnRoute
          })
const LearnPersonalityDisordersSlugRoute = LearnPersonalityDisordersSlugRouteImport.update({
            id: '/disorders/$slug',path: '/disorders/$slug',getParentRoute: () => LearnPersonalityRoute
          })
const LearnPersonalityGuidesSlugRoute = LearnPersonalityGuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => LearnPersonalityRoute
          })
const LearnPersonalityReflectionsSlugRoute = LearnPersonalityReflectionsSlugRouteImport.update({
            id: '/reflections/$slug',path: '/reflections/$slug',getParentRoute: () => LearnPersonalityRoute
          })





const BreathingRouteChildren = {
  BreathingCoreSlugRoute: BreathingCoreSlugRoute
}

const BreathingRouteWithChildren = BreathingRoute._addFileChildren(BreathingRouteChildren)




const GuestRouteChildren = {
  GuestTourRoute: GuestTourRoute
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)




const HowAreYouFeelingRouteChildren = {
  HowAreYouFeelingFeelingRoute: HowAreYouFeelingFeelingRoute,HowAreYouFeelingIndexRoute: HowAreYouFeelingIndexRoute
}

const HowAreYouFeelingRouteWithChildren = HowAreYouFeelingRoute._addFileChildren(HowAreYouFeelingRouteChildren)




const LearnCbtModuleRouteChildren = {
  LearnCbtModuleSkillRoute: LearnCbtModuleSkillRoute,LearnCbtModuleIndexRoute: LearnCbtModuleIndexRoute
}

const LearnCbtModuleRouteWithChildren = LearnCbtModuleRoute._addFileChildren(LearnCbtModuleRouteChildren)



const LearnCbtRouteChildren = {
  LearnCbtModuleRoute: LearnCbtModuleRouteWithChildren,LearnCbtIndexRoute: LearnCbtIndexRoute
}

const LearnCbtRouteWithChildren = LearnCbtRoute._addFileChildren(LearnCbtRouteChildren)




const LearnDbtModuleRouteChildren = {
  LearnDbtModuleSkillRoute: LearnDbtModuleSkillRoute,LearnDbtModuleIndexRoute: LearnDbtModuleIndexRoute
}

const LearnDbtModuleRouteWithChildren = LearnDbtModuleRoute._addFileChildren(LearnDbtModuleRouteChildren)



const LearnDbtRouteChildren = {
  LearnDbtModuleRoute: LearnDbtModuleRouteWithChildren,LearnDbtIndexRoute: LearnDbtIndexRoute
}

const LearnDbtRouteWithChildren = LearnDbtRoute._addFileChildren(LearnDbtRouteChildren)




const LearnPersonalityRouteChildren = {
  LearnPersonalityIndexRoute: LearnPersonalityIndexRoute,LearnPersonalityDisordersSlugRoute: LearnPersonalityDisordersSlugRoute,LearnPersonalityGuidesSlugRoute: LearnPersonalityGuidesSlugRoute,LearnPersonalityReflectionsSlugRoute: LearnPersonalityReflectionsSlugRoute
}

const LearnPersonalityRouteWithChildren = LearnPersonalityRoute._addFileChildren(LearnPersonalityRouteChildren)



const LearnRouteChildren = {
  LearnCbtRoute: LearnCbtRouteWithChildren,LearnDbtRoute: LearnDbtRouteWithChildren,LearnDepressionRoute: LearnDepressionRoute,LearnGlossaryRoute: LearnGlossaryRoute,LearnPersonalityRoute: LearnPersonalityRouteWithChildren,LearnPolyvagalLadderRoute: LearnPolyvagalLadderRoute,LearnSelfHarmSupportRoute: LearnSelfHarmSupportRoute,LearnShameBasedTraumaRoute: LearnShameBasedTraumaRoute,LearnWhatIsIfsRoute: LearnWhatIsIfsRoute,LearnWindowOfToleranceRoute: LearnWindowOfToleranceRoute,LearnIndexRoute: LearnIndexRoute,LearnAssessmentsSlugRoute: LearnAssessmentsSlugRoute,LearnAssessmentsAZRoute: LearnAssessmentsAZRoute,LearnAssessmentsTraumaHealingJourneyRoute: LearnAssessmentsTraumaHealingJourneyRoute,LearnMenAndTraumaSlugRoute: LearnMenAndTraumaSlugRoute,LearnMenAndTraumaCheckInRoute: LearnMenAndTraumaCheckInRoute,LearnMenAndTraumaToolsRoute: LearnMenAndTraumaToolsRoute,LearnTherapiesSlugRoute: LearnTherapiesSlugRoute,LearnTherapiesAssessmentRoute: LearnTherapiesAssessmentRoute,LearnTopicIndexRoute: LearnTopicIndexRoute,LearnAssessmentsIndexRoute: LearnAssessmentsIndexRoute,LearnMenAndTraumaIndexRoute: LearnMenAndTraumaIndexRoute,LearnTherapiesIndexRoute: LearnTherapiesIndexRoute,LearnTopicSectionResourceRoute: LearnTopicSectionResourceRoute,LearnAssessmentsPioneersSlugRoute: LearnAssessmentsPioneersSlugRoute,LearnMenAndTraumaToolsToolShopRoute: LearnMenAndTraumaToolsToolShopRoute,LearnTopicSectionIndexRoute: LearnTopicSectionIndexRoute,LearnAssessmentsPioneersIndexRoute: LearnAssessmentsPioneersIndexRoute
}

const LearnRouteWithChildren = LearnRoute._addFileChildren(LearnRouteChildren)




const AdminContractsRouteChildren = {
  AdminContractsIdRoute: AdminContractsIdRoute,AdminContractsNewRoute: AdminContractsNewRoute,AdminContractsTemplatesRoute: AdminContractsTemplatesRoute,AdminContractsIndexRoute: AdminContractsIndexRoute
}

const AdminContractsRouteWithChildren = AdminContractsRoute._addFileChildren(AdminContractsRouteChildren)




const AdminPaypalRouteChildren = {
  AdminPaypalOpsRoute: AdminPaypalOpsRoute,AdminPaypalReplayRoute: AdminPaypalReplayRoute
}

const AdminPaypalRouteWithChildren = AdminPaypalRoute._addFileChildren(AdminPaypalRouteChildren)




const AdminBroadcastsIdRouteChildren = {
  AdminBroadcastsIdDeliveryRoute: AdminBroadcastsIdDeliveryRoute
}

const AdminBroadcastsIdRouteWithChildren = AdminBroadcastsIdRoute._addFileChildren(AdminBroadcastsIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AbuseJournalRoute: AbuseJournalRoute,AccountCreatedRoute: AccountCreatedRoute,ActsOfSelfCareRoute: ActsOfSelfCareRoute,AdminRoute: AdminRoute,AdminLoginRoute: AdminLoginRoute,AdminTestimonialsRoute: AdminTestimonialsRoute,AffirmationsRoute: AffirmationsRoute,AiDisclaimerRoute: AiDisclaimerRoute,AppMembershipRoute: AppMembershipRoute,AromatherapyRoute: AromatherapyRoute,ArtBoardRoute: ArtBoardRoute,BilateralRoute: BilateralRoute,BillingRoute: BillingRoute,BrandColorsRoute: BrandColorsRoute,BreathingRoute: BreathingRouteWithChildren,CbtThoughtCardsRoute: CbtThoughtCardsRoute,CheckInRoute: CheckInRoute,CheckinUnsubscribeRoute: CheckinUnsubscribeRoute,ChooseMembershipRoute: ChooseMembershipRoute,ComingSoonRoute: ComingSoonRoute,CommunityRoute: CommunityRoute,CommunityGuidelinesRoute: CommunityGuidelinesRoute,CompleteMembershipRoute: CompleteMembershipRoute,ConfirmSubscriptionRoute: ConfirmSubscriptionRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,CoursesRoute: CoursesRoute,CreativeExpressionRoute: CreativeExpressionRoute,CreativeReflectionRoute: CreativeReflectionRoute,CrisisRoute: CrisisRoute,DailyPracticeRoute: DailyPracticeRoute,DashboardRoute: DashboardRoute,DbtSkillsRoute: DbtSkillsRoute,DisclaimerRoute: DisclaimerRoute,DissociationJournalRoute: DissociationJournalRoute,DreamReadingRoute: DreamReadingRoute,DreamReflectionsRoute: DreamReflectionsRoute,DreamsRoute: DreamsRoute,EarningsRoute: EarningsRoute,EftFlashcardsRoute: EftFlashcardsRoute,EnterpriseRoute: EnterpriseRoute,EscalationPathwayRoute: EscalationPathwayRoute,EulaRoute: EulaRoute,EventsRoute: EventsRoute,ExploreRoute: ExploreRoute,FaqRoute: FaqRoute,FavoritesRoute: FavoritesRoute,FlashcardsRoute: FlashcardsRoute,ForestBathingRoute: ForestBathingRoute,ForgotPasswordRoute: ForgotPasswordRoute,GardeningRoute: GardeningRoute,GovernanceRoute: GovernanceRoute,GriefLossRoute: GriefLossRoute,GroundingRoute: GroundingRoute,GuestRoute: GuestRouteWithChildren,GuideRoute: GuideRoute,GuidedJournalRoute: GuidedJournalRoute,HalloweenRoute: HalloweenRoute,HealingJourneysRoute: HealingJourneysRoute,HelpRoute: HelpRoute,HolisticWellbeingRoute: HolisticWellbeingRoute,HowAreYouFeelingRoute: HowAreYouFeelingRouteWithChildren,HowToStartRoute: HowToStartRoute,InnerChildRoute: InnerChildRoute,InstagramAccessRoute: InstagramAccessRoute,JoinCommunityRoute: JoinCommunityRoute,JournalRoute: JournalRoute,JournalHomeRoute: JournalHomeRoute,JournalReadingRoute: JournalReadingRoute,JournalsRoute: JournalsRoute,KnowYourPatternsRoute: KnowYourPatternsRoute,LearnRoute: LearnRouteWithChildren,LiveSessionsSurveyRoute: LiveSessionsSurveyRoute,LoginRoute: LoginRoute,MeditationsRoute: MeditationsRoute,MemberSupportRoute: MemberSupportRoute,MemberWelcomeRoute: MemberWelcomeRoute,MembershipRoute: MembershipRoute,MembershipBenefitsRoute: MembershipBenefitsRoute,MembershipJourneyRoute: MembershipJourneyRoute,MoodRoute: MoodRoute,MusicJournalRoute: MusicJournalRoute,MyEventsRoute: MyEventsRoute,MyHealingJourneyRoute: MyHealingJourneyRoute,MyMembershipRoute: MyMembershipRoute,MySavedWorkRoute: MySavedWorkRoute,NatureConnectionRoute: NatureConnectionRoute,NervousSystemResetRoute: NervousSystemResetRoute,OctoberRoute: OctoberRoute,PaymentHistoryRoute: PaymentHistoryRoute,PersonaliseRoute: PersonaliseRoute,PlanChangeRoute: PlanChangeRoute,PortalRoute: PortalRoute,PreferencesRoute: PreferencesRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ProfileRoute: ProfileRoute,QuickResetsRoute: QuickResetsRoute,QuizRoute: QuizRoute,RbDiscRoute: RbDiscRoute,RecoveryBoardRoute: RecoveryBoardRoute,RedeemRoute: RedeemRoute,RedeemGiftRoute: RedeemGiftRoute,RegisterMembershipRoute: RegisterMembershipRoute,RegulationCompassRoute: RegulationCompassRoute,RelaxationPracticesRoute: RelaxationPracticesRoute,ResetRoute: ResetRoute,ResetPasswordRoute: ResetPasswordRoute,ResourcesRoute: ResourcesRoute,RoadmapRoute: RoadmapRoute,SafetyStabilisationRoute: SafetyStabilisationRoute,SanctuaryRoute: SanctuaryRoute,SecurityRoute: SecurityRoute,SelfCareCalendarRoute: SelfCareCalendarRoute,SelfLoveRoute: SelfLoveRoute,ShadowJourneyRoute: ShadowJourneyRoute,ShadowWorkRoute: ShadowWorkRoute,SignupRoute: SignupRoute,SleepRoute: SleepRoute,SleepDreamsRoute: SleepDreamsRoute,SomaticRoute: SomaticRoute,SoundsRoute: SoundsRoute,SupportRoute: SupportRoute,TappingRoute: TappingRoute,TermsRoute: TermsRoute,TestimonialsRoute: TestimonialsRoute,TherapistApplicationRoute: TherapistApplicationRoute,TherapistDirectoryRoute: TherapistDirectoryRoute,TherapistTermsRoute: TherapistTermsRoute,TherapistsRoute: TherapistsRoute,TherapyApproachesRoute: TherapyApproachesRoute,ToolkitRoute: ToolkitRoute,TraumaResponseCheckInRoute: TraumaResponseCheckInRoute,TraumaResponseWheelRoute: TraumaResponseWheelRoute,TriggerJournalRoute: TriggerJournalRoute,UnsubscribeRoute: UnsubscribeRoute,UsPrivacyRightsRoute: UsPrivacyRightsRoute,VerifyEmailRoute: VerifyEmailRoute,WelcomeRoute: WelcomeRoute,WorkbooksRoute: WorkbooksRoute,WorkshopSignupRoute: WorkshopSignupRoute,YogaRoute: YogaRoute,YoureInRoute: YoureInRoute,AccountDevicesRoute: AccountDevicesRoute,AccountPrivacyRoute: AccountPrivacyRoute,AdminAccessAuditRoute: AdminAccessAuditRoute,AdminAudioHealthRoute: AdminAudioHealthRoute,AdminBlogRoute: AdminBlogRoute,AdminBoardCardsRoute: AdminBoardCardsRoute,AdminBreakingFreeRoute: AdminBreakingFreeRoute,AdminBroadcastsRoute: AdminBroadcastsRoute,AdminConfirmTestUserRoute: AdminConfirmTestUserRoute,AdminContentUpdatesRoute: AdminContentUpdatesRoute,AdminContractsRoute: AdminContractsRouteWithChildren,AdminCrisisAlertsRoute: AdminCrisisAlertsRoute,AdminDnsCheckRoute: AdminDnsCheckRoute,AdminEmailReviewRoute: AdminEmailReviewRoute,AdminEscalationCasesRoute: AdminEscalationCasesRoute,AdminEscalationPathwayRoute: AdminEscalationPathwayRoute,AdminEventsCalendarRoute: AdminEventsCalendarRoute,AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,AdminHalloweenTrackingRoute: AdminHalloweenTrackingRoute,AdminHealthMonitorRoute: AdminHealthMonitorRoute,AdminInvoicesRoute: AdminInvoicesRoute,AdminIssuesRoute: AdminIssuesRoute,AdminLaunchReadinessRoute: AdminLaunchReadinessRoute,AdminLeadConversionRoute: AdminLeadConversionRoute,AdminLibraryRoute: AdminLibraryRoute,AdminMembersRoute: AdminMembersRoute,AdminMembershipRoute: AdminMembershipRoute,AdminNotificationsRoute: AdminNotificationsRoute,AdminOwnershipPortabilityRoute: AdminOwnershipPortabilityRoute,AdminPaypalRoute: AdminPaypalRouteWithChildren,AdminQueryLogRoute: AdminQueryLogRoute,AdminQuestionsRoute: AdminQuestionsRoute,AdminSanctuaryRoute: AdminSanctuaryRoute,AdminSecureWithinRoute: AdminSecureWithinRoute,AdminShopRoute: AdminShopRoute,AdminStripeOpsRoute: AdminStripeOpsRoute,AdminStripeTestChecklistRoute: AdminStripeTestChecklistRoute,AdminSupportInboxRoute: AdminSupportInboxRoute,AdminTeamRolesRoute: AdminTeamRolesRoute,AdminTherapistApplicationsRoute: AdminTherapistApplicationsRoute,AdminTherapistDirectoryRoute: AdminTherapistDirectoryRoute,AdminTherapistEventsRoute: AdminTherapistEventsRoute,AdminWaitlistRoute: AdminWaitlistRoute,AdminWebhooksRoute: AdminWebhooksRoute,AnswersSlugRoute: AnswersSlugRoute,AuthCallbackRoute: AuthCallbackRoute,BlogSlugRoute: BlogSlugRoute,BreakingFreeJourneyRoute: BreakingFreeJourneyRoute,CheckoutCancelledRoute: CheckoutCancelledRoute,CheckoutCompleteRoute: CheckoutCompleteRoute,CheckoutFailedRoute: CheckoutFailedRoute,CheckoutGuestRoute: CheckoutGuestRoute,CheckoutPassRoute: CheckoutPassRoute,CheckoutSuccessRoute: CheckoutSuccessRoute,EftFlashcardsSlugRoute: EftFlashcardsSlugRoute,EventsSlugRoute: EventsSlugRoute,EventsCalendarRoute: EventsCalendarRoute,HalloweenDecksRoute: HalloweenDecksRoute,HalloweenJournalRoute: HalloweenJournalRoute,IntegrateComfortCollectionsRoute: IntegrateComfortCollectionsRoute,IntegrateFindingAweRoute: IntegrateFindingAweRoute,IntegrateHiddenStrengthsRoute: IntegrateHiddenStrengthsRoute,IntegrateLettersNeverSentRoute: IntegrateLettersNeverSentRoute,IntegrateLifeWorthLivingRoute: IntegrateLifeWorthLivingRoute,IntegrateMicroAdventuresRoute: IntegrateMicroAdventuresRoute,IntegrateSelfLeadershipRoute: IntegrateSelfLeadershipRoute,IntegrateTheRecoveryHomeRoute: IntegrateTheRecoveryHomeRoute,IntegrateTriggersAsTeachersRoute: IntegrateTriggersAsTeachersRoute,IntegrateYourInnerTeamRoute: IntegrateYourInnerTeamRoute,LibrarySlugRoute: LibrarySlugRoute,LibraryHalloweenGroundingRoute: LibraryHalloweenGroundingRoute,LibraryTeenBoundariesWorkbookRoute: LibraryTeenBoundariesWorkbookRoute,PaypalReturnRoute: PaypalReturnRoute,RetentionTokenRoute: RetentionTokenRoute,SecureWithinJourneyRoute: SecureWithinJourneyRoute,SettingsAccessibilityRoute: SettingsAccessibilityRoute,SettingsEmailPreferencesRoute: SettingsEmailPreferencesRoute,ShopSlugRoute: ShopSlugRoute,ShopDownloadsRoute: ShopDownloadsRoute,ShopGiftThanksRoute: ShopGiftThanksRoute,ShopSuccessRoute: ShopSuccessRoute,SomaticPracticeRoute: SomaticPracticeRoute,TherapistAvailabilityTokenRoute: TherapistAvailabilityTokenRoute,TherapistsTherapistIdRoute: TherapistsTherapistIdRoute,AnswersIndexRoute: AnswersIndexRoute,AuthIndexRoute: AuthIndexRoute,BlogIndexRoute: BlogIndexRoute,BreakingFreeIndexRoute: BreakingFreeIndexRoute,LibraryIndexRoute: LibraryIndexRoute,SecureWithinIndexRoute: SecureWithinIndexRoute,ShopIndexRoute: ShopIndexRoute,AdminBroadcastsIdRoute: AdminBroadcastsIdRouteWithChildren,AdminUsersUserIdRoute: AdminUsersUserIdRoute,BlogCategoryCategoryRoute: BlogCategoryCategoryRoute,BreakingFreeDayDayRoute: BreakingFreeDayDayRoute,GiftVoucherCodeRoute: GiftVoucherCodeRoute,SecureWithinDayDayRoute: SecureWithinDayDayRoute,ShopCategoryCategoryRoute: ShopCategoryCategoryRoute,SignContractTokenRoute: SignContractTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)